import SingleBookingPageVue from "@/pages/booking/BookingPage/index.vue";
import FacilityBookingPageVue from "@/pages/booking/FacilityBookingPage.vue";
import { createWebHistory, createRouter } from "vue-router";
import HomePageVue from "@/pages/booking/HomePage/index.vue";
// OLD FLOW (disabled): Details checkout page — replaced by booking wizard on BookingPage
// import DetailsPageVue from "@/pages/booking/DetailsPage/index.vue";
import SummaryPage from "@/pages/booking/SummaryPage/index.vue";
import * as ENV from "@/config.js";
import formSummaryPage from "@/pages/booking/formSummaryPage/index.vue";
import endeavourDirectBookingVue from "@/pages/booking/endeavourDirectBooking/index.vue";
import endeavourFreeBookingVue from "@/pages/booking/endeavourFreeBooking/index.vue";
import EventsVenueBookingVue from "@/pages/booking/EventsVenueBooking/index.vue";
import OnetimeLoginVue from "@/pages/booking/OnetimeLogin/index.vue";
import { getBookingVenueTypeSettings } from "@/store/vuexStore";
import { verifyOnetimeToken, checkExistingOnetimeUser } from "../../server/config";
import { isEventsVenueVenueType } from "@/utils/eventsVenueMatch.js";
import { isEventsBookingFacility } from "@/constants/eventsFacilityPromo.js";
import {
  getOtpSession,
  mapOtpProfileFromResponse,
  saveOtpSession,
  syncLegacyOtpSessionFromStorage,
} from "@/utils/otpSession.js";

let facitlity = ENV.VUE_APP_FACILITY;

const routes = [
  {
    path: `/bookingapp/${facitlity}`,
    name: "Home",
    component: HomePageVue,
  },
  {
    path: `/bookingapp/${facitlity}/booking`,
    name: "singleBooking",
    component: SingleBookingPageVue,
    meta: {
      requiresAuth: true, // Mark as protected route
    },
  },
  {
    path: `/bookingapp/${facitlity}/facilityBooking`,
    name: "facilityBooking",
    component: FacilityBookingPageVue,
  },

  // OLD FLOW (disabled): multi-step Details checkout — redirect to wizard booking page
  {
    path: `/bookingapp/${facitlity}/details`,
    name: "details",
    redirect: (to) => ({
      path: `/bookingapp/${facitlity}/booking`,
      query: to.query,
    }),
  },
  // {
  //   path: `/bookingapp/${facitlity}/details`,
  //   name: "details",
  //   component: DetailsPageVue,
  // },
  {
    path: `/bookingapp/${facitlity}/summarypage`,
    name: "summary",
    component: SummaryPage,
  },
  {
    path: `/bookingapp/endeavourreserve/directbooking/summary`,
    name: "directbookingsummary",
    component: formSummaryPage,
  },
  {
    path: `/bookingapp/endeavourreserve/directbooking`,
    name: "endeavourDirectBooking",
    component: endeavourDirectBookingVue,
  },
  {
    path: `/bookingapp/endeavourclubs/freebooking`,
    name: "endeavourFreeBooking",
    component: endeavourFreeBookingVue,
  },
  {
    path: `/bookingapp/${facitlity}/eventsbooking`,
    name: "eventsVenueBooking",
    component: EventsVenueBookingVue,
  },
  {
    path: `/bookingapp/${facitlity}/booking/onetimelogin`,
    name: "onetimelogin",
    component: OnetimeLoginVue,
  },
];

const router = createRouter({
  mode: "history",
  base: `/bookingapps/${facitlity}/`,
  history: createWebHistory(),
  routes,
});

// Global route guard and check if  route requires authentication (private venue) +  token
router.beforeEach(async (to, from, next) => {
  let VenueTypeSettings = getBookingVenueTypeSettings();

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let venueTypePathQuery = to.query.venueType?.replaceAll("_", " ");

    // Find venue settings && check if it's private
    const venueSetting = VenueTypeSettings.find(v => v.venueType === venueTypePathQuery);
    if (venueSetting && venueSetting.enablePrivateVenue) {
      const token = sessionStorage.getItem("onetimeToken");
      let path = `/bookingapp/${ENV.VUE_APP_FACILITY}/booking`;
      
      if (!token) {
        return next({ path: path + "/onetimelogin?venueType=", query: { venueType: to.query.venueType } });
      }

      try {
        const verifyToken = await verifyOnetimeToken(token);
        const loginVenueType = verifyToken.response.venuetype;
        
        if (verifyToken.status !== 1 || loginVenueType !== venueTypePathQuery) {
          return next({ path: path + "/onetimelogin?venueType=", query: { venueType: to.query.venueType } });
        }

        syncLegacyOtpSessionFromStorage();
        const existingSession = getOtpSession() || {};
        const verifiedEmail =
          verifyToken.response?.email ||
          existingSession.email ||
          sessionStorage.getItem("email") ||
          "";

        saveOtpSession({
          ...existingSession,
          facility:
            verifyToken.response?.facility ||
            existingSession.facility ||
            ENV.VUE_APP_FACILITY,
          email: verifiedEmail,
          venueType: loginVenueType,
          token,
          otpUserId:
            verifyToken.response?.id ||
            existingSession.otpUserId ||
            sessionStorage.getItem("otpUserId") ||
            "",
        });

        if (!getOtpSession()?.otpUserId && verifiedEmail) {
          try {
            const user = await checkExistingOnetimeUser(
              verifiedEmail,
              venueTypePathQuery
            );
            if (user?.status === 1 && user.response?.id) {
              sessionStorage.setItem("otpUserId", user.response.id);
              saveOtpSession({
                ...getOtpSession(),
                otpUserId: user.response.id,
                profile: mapOtpProfileFromResponse(user.response),
                bookingHoursRemaining: Number(user.response.bookinghours ?? 0),
              });
            }
          } catch (error) {
            console.error("Failed to refresh OTP user session:", error);
          }
        }

        if (to.query.venueType=="BOOK_A_FREE_SESSION") {
          let path = `/bookingapp/endeavourclubs/freebooking`;
          return next({ path: path, query:{ venueType: to.query.venueType } });
        }
        if (
          isEventsBookingFacility() &&
          isEventsVenueVenueType(to.query.venueType)
        ) {
          return next({
            path: `/bookingapp/${ENV.VUE_APP_FACILITY}/eventsbooking`,
            query: { venueType: to.query.venueType },
          });
        }

        // User verified successfully
        return next();
      } catch (error) {
        // Token verification failed
        return next({ path: path + "/onetimelogin?venueType=", query: { venueType: to.query.venueType } });
      }
    }
  }

  // Proceed with the navigation if authenticated or if it's a public route
  next();
});

export default router;
